// extracted by mini-css-extract-plugin
export default {"checkbox":"FloCheckbox_checkbox__hyxEs","removeMargin":"FloCheckbox_removeMargin__F4TPK"};